import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import FileSaver from "file-saver";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class VenueMenuService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async downloadMenu(venueId: string, id: string, fileName: string): Promise<void> {
        const data = await firstValueFrom(this.http.post("/fonzie/customer-instance-venue/" + venueId + "/menu/" + id, {}, {headers: this.auth.getHttpHeaderOptions(), responseType: "blob"}));
        FileSaver.saveAs(data, fileName);
    }

    async uploadMenu(venueId: string, file: File): Promise<void> {
        const formData: FormData = new FormData();
        formData.append("uploadedFileName", file);
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/menu", formData, {headers: this.auth.getHttpHeaderOptionsForFile()}));
    }

    async deleteMenu(venueId: string, id: string): Promise<void> {
        return firstValueFrom(this.http.delete<void>("/fonzie/customer-instance-venue/" + venueId + "/menu/" + id, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
